import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "icon-container center-x" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "fs-smaller grey1-grey1-color" }
const _hoisted_5 = { class: "fw-b fs-smaller" }
const _hoisted_6 = { class: "fs-smaller grey1-grey1-color" }
const _hoisted_7 = { class: "fw-b fs-smaller" }

import { IonRow, IonCol, IonIcon } from '@ionic/vue';
import { computed } from 'vue';

import ButtonBase from "@/components/button/ButtonBase.vue";

import { convertNumberWithComma } from "@/functions/converter";

import { ION_VARIANT } from '@/types/enum/ionicEnum';
import { CatalogItem } from '@/types/supplier';
import { CURRENCY_EUR } from "@/assets/variables";
import { HIGHLIGHT_COLOR, HIGHLIGHT_MESSAGE } from "@/types/enum/propEnum";
import convertFormat from "@/functions/luxon";
import { DATE_TIME_FORMAT } from "@/types/enum/luxonEnum";
import HighlightBox from "@/components/card/HighlightBox.vue";
import SkeletonBase from "@/components/various/SkeletonBase.vue";

interface ScanDetailsEntryProps {
    entry: CatalogItem;
    edit?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ScanDetailsEntry',
  props: {
    entry: {},
    edit: { type: Boolean }
  },
  emits: ["edit"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const total = computed<number>(() => Number(props.entry.quantity ?? 0) * Number(props.entry.price))

const handleEditClick = (event: TouchEvent | MouseEvent): void => {
    event.stopPropagation()
    emit('edit')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonRow), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCol), {
          size: "2",
          class: "center-x px-1"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (__props.entry.imageLink)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    alt: "",
                    src: (__props.entry.imageLink.startsWith('/')) ? `https://app.octopusorder.com${__props.entry.imageLink}` : __props.entry.imageLink,
                    style: {"max-height":"100%"}
                  }, null, 8, _hoisted_3))
                : (_openBlock(), _createBlock(_unref(IonIcon), {
                    key: 1,
                    src: "assets/icon/item.svg",
                    class: "max-size purple-purple-color"
                  }))
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonCol), { class: "center-x flex-d-c" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "p-0 fw-b" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.entry.name), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonRow), { class: "mt-1" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "fs-smaller grey1-grey1-color p-0" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.entry.packaging), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonRow), { class: "mt-1" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "fs-smaller grey1-grey1-color p-0" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('label.articleNo')) + ": " + _toDisplayString(__props.entry.itemNumber), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (__props.edit)
          ? (_openBlock(), _createBlock(_unref(IonCol), {
              key: 0,
              size: "auto",
              class: "center-y"
            }, {
              default: _withCtx(() => [
                _createVNode(ButtonBase, {
                  color: _unref(ION_VARIANT).GREY_4,
                  class: "round-button grey1-grey1-color inherit-color no-shadow",
                  style: {"width":"50px","height":"50px"},
                  onClick: handleEditClick
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      src: "assets/icon/pencil.svg",
                      class: "round-button-icon"
                    })
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (__props.entry.quantity)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 0,
          class: "stacked-cols px-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              size: "3",
              class: "fixed-width-xxs-screen"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('object.amount')), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(__props.entry.quantity), 1)
              ]),
              _: 1
            }),
            (__props.entry.price)
              ? (_openBlock(), _createBlock(_unref(IonCol), { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('object.price')), 1),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(convertNumberWithComma)(Number(__props.entry.price).toFixed(3))) + " " + _toDisplayString(_unref(CURRENCY_EUR)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (total.value)
              ? (_openBlock(), _createBlock(_unref(IonCol), {
                  key: 1,
                  size: "4",
                  class: "ion-text-end"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})